module.exports = __webpack_public_path__ + "static/media/fish-tank.e5c946ad.png";